// extracted by mini-css-extract-plugin
export default {"container":"CarPage_container__Rjw4O","textContainer":"CarPage_textContainer__793hl","title":"CarPage_title__qUKsi","subtitle":"CarPage_subtitle__PkVjQ"};